// src/components/RippleProvider.tsx
// The click-ripple animation is opt-in: callers that want it pass
// `enabled={true}`. The default of `false` avoids a 1 s DOM mutation
// on every click and keeps the UI free of a distracting global ripple.
import React, { ReactNode, useEffect } from "react";

interface RippleProviderProps {
  children: ReactNode;
  /** Defaults to false. Set true to re-enable the click ripple. */
  enabled?: boolean;
}

const RippleProvider: React.FC<RippleProviderProps> = ({ children, enabled = false }) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const handleClick = (e: MouseEvent) => {
      const ripple = document.createElement("span");
      ripple.className = "global-ripple";

      ripple.style.left = `${e.clientX}px`;
      ripple.style.top = `${e.clientY}px`;

      document.body.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
      }, 1000); // match with animation duration
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [enabled]);

  return <>{children}</>;
};

export default RippleProvider;
